<template>
  <div>
    <Topo :btnLogout="true" :acessoRestritoMenu="false"></Topo>
    <Migalha label="Cadastro Fornecedor"></Migalha>
    <v-layout row wrap>
      <v-flex xs12 md6 class="textoBoasVindas">
        <h1 class="text-red">
          <strong class="text-uppercase">{{$t('label.cadastro')}}</strong>
        </h1>
        <h4 class="text-primary">
          <strong>{{$t('titulo.cadastrarComoFornecedor')}}</strong>
        </h4>
        <div class="tituloStatusCadastro">
          <strong>
            {{$t('titulo.statusSituacaoSolicitacao')}}
            <span
              class="text-atencao"
            >{{$t('titulo.pendenteDeEnvio')}}</span>
          </strong>          
        </div>        
      </v-flex>      
      <mascote :model="model" :valores="mascote" :erros="erros"></mascote>
    </v-layout>
    
    
<v-layout row wrap p-t-50 v-show="erros.erro">
    <v-flex xs12 p-t-20>
    <v-alert
    :value="erros.erro"
    type="error"
    outline
    >
    <div  v-html="erros.msg"></div>
    
    </v-alert>
    </v-flex>
     </v-layout>   

    <div class="abasCadastro">
      <v-tabs v-model="activeTab" slider-color="ss" class="abasStyle">
        <v-flex xs12>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-dados','abaErro':erros.abaErro=='tab-dados'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-dados')"
          >
            Dados
            <br>Do
            <strong>Fornecedor</strong>
          </v-tab>
          <v-tab
            v-if="model.tipFornecedor != 'F'"
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-hab-juridica','abaErro':erros.abaErro=='tab-hab-juridica'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-hab-juridica')"
          >Habilitação
            <br>
            <strong>Jurídica</strong>
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-familia','abaErro':erros.abaErro=='tab-familia'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-familia')"
          >
            <strong>Família</strong>
          </v-tab>

          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-qualificacaoTecnica','abaErro':erros.abaErro=='tab-qualificacaoTecnica'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-qualificacaoTecnica')"
          >
          <strong>Qualificação</strong>
            <br>Técnica
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-regularidadeFiscal','abaErro':erros.abaErro=='tab-regularidadeFiscal'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-regularidadeFiscal')"
          >
            <strong>Regularidade</strong> Fiscal
            <br>e Trabalhista
          </v-tab>
          <v-tab
            v-if="model.tipoCertificado == 1"
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-qualificacao','abaErro':erros.abaErro=='tab-qualificacao'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-qualificacao')"
          >
            <strong>Qualificação</strong>
            <br>econômico-financeira
          </v-tab>
          <v-tab
            active-class
            v-bind:class="{ 'abaAtiva': abaAtiva=='tab-formulariosDeclaracoes','abaErro':erros.abaErro=='tab-formulariosDeclaracoes'}"
            :href="'#'+abaAtiva"
            @click="setAba('tab-formulariosDeclaracoes')"
          >
            Formulários
            <br>e
            <strong>Declarações</strong>
          </v-tab>
        </v-flex>
        <v-tab-item value="tab-dados">
          <v-form v-model="valid" ref="dadosBasicosForm">
            <dadosBasicos :model="model" :fornecedorDeclaracaoVm="fornecedorDeclaracaoVm" :OldModel="OldModel" :upload="upload" :acaoTela="acaoTela" :enums="enums" :isAlteracao="isAlteracao" :listaDocFornecSolicitacao="listaDocFornecSolicitacao"></dadosBasicos>
          </v-form>
        </v-tab-item>
        <v-tab-item value="tab-hab-juridica">
          <v-form
            v-model="valid"
            v-show="activeTab=='tab-hab-juridica'"
            ref="habilitacaoJuridicaForm"
          >
            <habilitacaoJuridica 
              :erroHabilitacaoJuridica="erros" 
              :model="model" :OldModel="OldModel" 
              :isAlteracao="isAlteracao"
              :acaoTela="acaoTela" 
              :upload="upload"
              :hasErroDocHabilitacao="hasErroDocHabilitacao" 
              :listaDocFornecSolicitacao="listaDocFornecSolicitacao">
            </habilitacaoJuridica>
          </v-form>
        </v-tab-item>
        <v-tab-item value="tab-familia">
          <v-form v-model="valid" ref="familia">
            <familia 
              :model="model" 
              :erroFamilia="erros" 
              :getListaDocsQualificacaoTecnica="getListaDocsQualificacaoTecnica"
              :hasError="hasErrorFamilia"
              v-if="abaAtiva == 'tab-familia'">
              </familia>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-qualificacaoTecnica">
          <v-form v-model="valid" ref="qualificacaoTecnica" v-if="activeTab=='tab-qualificacaoTecnica'">
            <qualificacaoTecnica :model="model" :OldModel="OldModel" :isAlteracao="isAlteracao" :listaDocsQualificacaoTecnica="listaDocsQualificacaoTecnica" :erroQualificacaoTecnica="erros" :fornecedorQualificacaoTecnicaVm="fornecedorQualificacaoTecnicaVm"></qualificacaoTecnica>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-regularidadeFiscal">
          <v-form
            v-model="valid"
            ref="regularidadeFiscal"
            v-if="activeTab=='tab-regularidadeFiscal'"
          >
            <regularidadeFiscal 
              :model="model" 
              :OldModel="OldModel" 
              :isAlteracao="isAlteracao"
              :acaoTela="acaoTela" 
              :enums="enums" 
              :tipoDocumento="tipoDocumento" 
              :hasError="hasErrorRegularidadeFiscal">
            </regularidadeFiscal>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-qualificacao" >
          <v-form v-model="valid" ref="qualificacaoEconomica" v-if="activeTab=='tab-qualificacao'">
            <qualificacaoEconomica
              :modelQualificacao="modelQualificacao"
              :model="model"
              :enums="enums"
              :pontuacaoIndices="pontuacaoIndices"
              :totaisContas="totaisContas"
              :OldModel="OldModel" 
              :isAlteracao="isAlteracao"
            ></qualificacaoEconomica>
          </v-form>
        </v-tab-item>

        <v-tab-item value="tab-formulariosDeclaracoes">
          <v-form
            v-model="valid"
            ref="formulariosDeclaracoes"
            v-if="activeTab=='tab-formulariosDeclaracoes'"
          >
            <formulariosDeclaracoes :model="model" :OldModel="OldModel" :enums="enums" :fornecedorDeclaracaoVm="fornecedorDeclaracaoVm"  :isAlteracao="isAlteracao" :listaDocFornecSolicitacao="listaDocFornecSolicitacao"></formulariosDeclaracoes>
          </v-form>
        </v-tab-item>
      </v-tabs>
       
      <v-layout row d-inline class="p-t-30">
        <v-flex xs6 sm4 left p-t-30 v-if="$verificaPerfilCadastrador() || activeTab != 'tab-dados'">
          <v-btn large color="info" @click="voltar()">
            <v-icon dark left>arrow_back</v-icon>&nbsp;VOLTAR
          </v-btn>
        </v-flex>
        <v-flex v-if="this.activeTab == 'tab-formulariosDeclaracoes'" xs6 sm4 right p-t-30>
          <v-btn large color="info" @click="enviar()">ENVIAR</v-btn>
        </v-flex>
             
         
        <v-flex v-else xs6 sm4 right p-t-30>
          <v-btn large color="info" @click="cadastroFornecedor()">CONTINUAR
            <v-icon dark right>arrow_forward</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>

      <v-dialog v-model="dialog" max-width="320" persistent>
        <v-card>
          <v-card-title class="headline grey lighten-2">Parabéns</v-card-title>
          <v-card-text v-if="!$verificaPerfilCadastrador() && this.model.possuiCertificadoDigital == '1'">
            Envio realizado com sucesso.<br>             
            <br>Número da solicitação
            <strong>{{this.model.numSolicitacao}}</strong>.
          </v-card-text>
          <v-card-text v-else>
            <p v-if="!$verificaPerfilCadastrador() && this.model.possuiCertificadoDigital == '0'" >
              Envio realizado com sucesso.<br>
              Para prosseguimento da análise, aguardamos o envio do Termo de Declaração de Concordância e Veracidade.
              A entrega deverá ser realizada pessoalmente no posto de Serviço de Atendimento ao Fornecedor – SAF
              ou em um dos Postos Avançados de Cadastro de Fornecedores - PCF. Para ver os endereços 
              <a class="linkExterno" href="https://www.comprasnet.ba.gov.br/content/fornecedor-1" target="_blank" title="Comprasnet.BA">clique aqui</a> ou 
              acesse o site Comprasnet.BA e navegue em Fornecedor>Entrega de Documentos.
              Caso o Termo de Declaração de Concordância e Veracidade não seja recebido em até 30 dias, esta solicitação 
              será excluída automaticamente pelo sistema.
              <br />Número da solicitação:
              <strong>{{this.model.numSolicitacao}}</strong>          
            </p>
            <p v-else>
               Envio realizado com sucesso.<br>
            </p>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="fecharDialogEnviar(model)">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

       <v-dialog v-model="dialogForm" persistent width="50%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Parabéns</v-card-title>
          <v-card-text>
            Envio realizado com sucesso.<br>
            Para prosseguimento da análise, aguardamos o envio do Termo de Declaração de Concordância e Veracidade.
            A entrega deverá ser realizada pessoalmente no posto de Serviço de Atendimento ao Fornecedor – SAF
            ou em um dos Postos Avançados de Cadastro de Fornecedores - PCF. Para ver os endereços 
            <a class="linkExterno" href="https://www.comprasnet.ba.gov.br/content/fornecedor-1" target="_blank" title="Comprasnet.BA">clique aqui</a> ou 
            acesse o site Comprasnet.BA e navegue em Fornecedor>Entrega de Documentos.
            Caso o Termo de Declaração de Concordância e Veracidade não seja recebido em até 30 dias, esta solicitação 
            será excluída automaticamente pelo sistema.
            <br />Número da solicitação:
            <strong>{{this.model.numSolicitacao}}</strong><br>
           
            
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="fecharDialogFormEnviar(model)">Termo de Concordância e Veracidade</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>


      <v-dialog v-model="dialogFormSim" persistent width="50%">
        <v-card>
          <v-card-title class="headline grey lighten-2">Parabéns</v-card-title>
          <v-card-text>
            Envio realizado com sucesso.<br>           
            <br>Número da solicitação
            <strong>{{this.model.numSolicitacao}}</strong><br>           
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" @click="fecharDialogEnviar(model)">OK</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Popup de confirmação de dados cadastrais -->
      <v-dialog v-model="dialogConfirmacaoDados" persistent max-width="550px">
        <v-card>
          <v-card-title class="headline grey lighten-2" style="justify-content: center;">
            Atualização de Dados Cadastrais
          </v-card-title>
          <v-card-text>
            <div style="margin-bottom: 16px;">
              Para garantir que seus dados estejam sempre atualizados, revise e confirme as seguintes informações. Caso necessário, edite antes de continuar.
            </div>
            <div>
              <strong>Dados do Fornecedor</strong>
              <v-divider class="my-2"></v-divider>
              <div><b>E-mail:</b> {{ model.endEmail }}</div>
              <div><b>Telefone:</b> {{ model.numTelefone }}</div>
              <div><b>Celular:</b> {{ model.numCelular }}</div>
            </div>
            <div style="margin-top: 16px;">
              <strong>Endereço</strong>
              <v-divider class="my-2"></v-divider>
              <div><b>Logradouro:</b> {{ model.endLogradouro }}</div>
              <div><b>Número:</b> {{ model.endNumero }}</div>
              <div><b>Complemento:</b> {{ model.endComplemento }}</div>
              <div><b>CEP:</b> {{ model.endCep }}</div>
            </div>
          </v-card-text>
          <v-card-actions style="justify-content: space-between;">
            <v-btn
              color="error"
              class="white--text"
              :style="{ width: '250px', height: '35px', fontWeight: 'bold', fontSize: '13px', left: '8.5px', top: '-8px' }"
              @click="editarDados"
            >
            
              EDITAR DADOS
            </v-btn>
            <v-btn
              color="primary"
              class="white--text"
              :style="{ width: '250px', height: '35px', fontWeight: 'bold', fontSize: '13px', right: '8.5px', top: '-8px' }"
              @click="confirmarDados"
            >
              CONFIRMAR DADOS
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      
    </div>
  </div>
</template>

<script>
import fornecedorMixin from "./components/fornecedorMixin";
import dadosBasicos from "./dados-basicos";
import habilitacaoJuridica from "./habilitacao-juridica";
import familia from "./familia";
import qualificacaoTecnica from "./qualificacaoTecnica";
import mascote from "./components/mascote";
import regularidadeFiscal from "./regularidade-fiscal";
import qualificacaoEconomica from "./qualificacao-economica";
import formulariosDeclaracoes from "./formularios-declaracoes";
import Migalha from "../../components/migalha";
import Topo from "../../components/Topo";
export default {
  name: "fornecedor-form",
  mixins: [fornecedorMixin],
  components: { /*Componentes utilizados*/
    dadosBasicos,
    habilitacaoJuridica,
    familia,
    qualificacaoTecnica,
    regularidadeFiscal,
    qualificacaoEconomica,
    formulariosDeclaracoes,
    mascote,
    Migalha,
    Topo
  },

  data() {
    return {
      dialogConfirmacaoDados: false,
    };
  },
  
};

</script>

<style>
.abaAtiva a {
  color: #349fbe !important;
}

html {
  scroll-behavior: smooth;
}

.linkExterno {
  font-weight: bold;
}

.linkExterno:hover {
  text-decoration: underline;
}
</style>
